import styled from "styled-components";

export const ContentContainer = styled.div`
  width: 100%;
  min-height: 100vh; /* full viewport height */
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: rgba(255, 255, 255, 0);
  background-image: url("https://res.cloudinary.com/dht699doy/image/upload/c_limit,w_1920,q_auto,f_auto/v1791899929/bg_image2_gwlvws.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  padding: 40px;
  margin: 0 auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    padding: 15px;
  }

  @media (max-width: 768px) {
    padding: 15px;
    background-position: top center;
  }

  @media (max-width: 480px) {
    padding: 5px 0;
    background-position: top center;
  }

  @media print {
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
`;


// export const  HeaderSection = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 15px;
//   padding: 30px;
//   border-bottom: 2px solid rgba(102, 126, 234, 0.1);

//   @media (max-width: 768px) {
//     padding: 10px;
//     grid-template-columns: 1fr;
//     gap: 10px;
//   }
// `;

export const HeaderSection = styled.div`
  flex: 0 0 auto; /* fixed height (content based) */
  padding: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 10px;
  }
`;

export const  CompanySection = styled.div`
  display: flex;
  align-items: stretch;
  gap: 12px;
  min-height: 120px; // Ensures consistent height
`;

export const  CompanyLogo = styled.div`
  width: 120px;
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 48px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }
`;

export const  CompanyInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

export const  CompanyName = styled.h1`
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  background: linear-gradient(135deg, #10a969 0%, #0e5033 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  transition: all 0.2s ease;
  flex-wrap: wrap; /* allows text to wrap under icon if space is tight */

  &:hover {
    transform: translateX(4px);
  }

  @media (max-width: 480px) {
    gap: 6px;
    padding: 6px 0;
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0; /* prevents flex children from overflowing */
  
  @media (max-width: 480px) {
    gap: 4px;
  }
`;

export const ContactIcon = styled.span`
  font-size: 18px;
  width: 32px;  /* slightly larger tap target */
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e4bc87 0%, #e4bc87 100%);
  border-radius: 8px;
  flex-shrink: 0;
  
  img {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
    font-size: 16px;
    img {
      width: 18px;
      height: 18px;
    }
  }
`;


export const  ContactText = styled.span`
  font-size: 16px;
  color: #e4bc87;
  font-weight: 500;
  transition: color 0.2s ease;

  ${ContactItem}:hover & {
    color: #10a969;
  }
`;

export const  CompanyCard = styled.div`
  padding: 24px;
  transition: all 0.3s ease;
  border-radius: 16px;

  background: rgba(248, 247, 247, 0.24);
  backdrop-filter: blur(5px);


  @media (max-width: 768px) {
    padding: 10px;

    ${CompanySection} {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 5px;
      min-height: auto;
    }

    ${CompanyLogo} {
      width: 100px;
      min-width: 100px;
    }

    ${CompanyName} {
      font-size: 28px;
    }

    ${ContactText} {
      font-size: 14px;
    }
  }
`;

export const TravelerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  padding: 16px; /* adds breathing room on smaller screens */
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: 16px; /* slightly smaller gaps on tablets */
    padding: 12px;
  }

  @media (max-width: 480px) {
    gap: 12px; /* tighter spacing for small phones */
    padding: 8px;
  }
`;

export const  SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const  TravelerIcon = styled.div`
  font-size: 24px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e4bc87 0%, #e4bc87 100%);
  border-radius: 10px;
  color: red;
  box-shadow: 0 2px 8px rgba(115, 72, 44, 0.2);
  img {
    width: 30px;
    height: 30px;
  }
`;

export const  SectionTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #e4bc87;
  -webkit-background-clip: text;
  background-clip: text;
`;

export const TravelerContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between; /* distributes children better */
  flex-wrap: wrap; /* allows wrapping on small screens */
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column; /* stack vertically */
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
  }
`;

export const TravelerInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border-radius: 12px; /* keeps it modern */

  @media (max-width: 768px) {
    flex-direction: column; /* stack content */
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
  }

  @media (max-width: 480px) {
    gap: 8px;
    padding: 12px;
  }
`;


export const  TravelerAvatar = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10a969 0%, #10a969 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(115, 72, 44, 0.3);
  border: 3px solid white;
`;

export const  TravelerDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const  TravelerName = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.2;
`;

export const  TravelerEmail = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #e4bc87;
  font-weight: 500;
  transition: color 0.2s ease;
`;

export const  TravelerCard = styled.div`
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
  height: fit-content;
  min-height: 168px;
  background: rgba(248, 247, 247, 0.24);
  backdrop-filter: blur(15px);

  @media (max-width: 768px) {
    padding: 10px;
    min-height: auto;

    ${SectionHeader} {
      gap: 8px;
    }

    ${TravelerIcon} {
      width: 32px;
      height: 32px;
      font-size: 18px;
    }

    ${SectionTitle} {
      font-size: 20px;
    }

    ${TravelerInfo} {
      flex-direction: column;
      text-align: center;
      gap: 12px;
      padding: 16px;
    }

    ${TravelerAvatar} {
      width: 48px;
      height: 48px;
      font-size: 20px;
    }

    ${TravelerName} {
      font-size: 18px;
    }
  }
`;

export const BodySection = styled.div`
  flex: 1; /* takes all remaining space */
  padding: 30px;
  overflow-y: auto; /* prevents content cutting */
`;

export const HeaderSubSection = styled.div`
  flex: 1; /* takes all remaining space */
  padding: 30px;
`;

export const ItineraryHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  background: rgba(248, 247, 247, 0.25);
  backdrop-filter: blur(15px);
  padding: 20px;
  border-radius: 16px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
    padding: 16px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
    padding: 12px;
    border-radius: 10px;
  }
`;

export const ItineraryTitle = styled.h1`
  margin: 0 0 10px 0;
  font-size: 36px;
  font-weight: 700;
  color: #e4bc87;
  // text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  // background: linear-gradient(45deg, #0e5033, #0e5033, #0e5033);
  -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #e4bc87;

  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 8px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
    margin-bottom: 6px;
  }
`;

export const TotalCost = styled.div`
  display: inline-block;
  padding: 12px 24px;
  color: #e4bc87;
  font-weight: 500;
  font-size: 18px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 16px;
  }

  @media (max-width: 480px) {
    padding: 8px 16px;
    font-size: 14px;
  }
`;

export const DaysContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  &.print-mode {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0; /* avoid accidental spacing across pages */
  }
`;


// export const  DaysContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 30px;

//   &.print-mode {
//     flex-direction: row;
//     flex-wrap: wrap;
//     gap: 0; /* avoid accidental spacing across pages */
//   }
// `;

export const DayCard = styled.div`
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.68);
  backdrop-filter: blur(10px);
  page-break-after: always;

  &.print-mode & {
    width: 50%;             /* 2 cards per row */
    box-sizing: border-box;
    page-break-inside: avoid;
  }

  /* Every 2nd card triggers page break */
  &.print-mode &:nth-of-type(2n) {
    page-break-after: always;
  }
`;

export const DayHeader = styled.div`
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 15px 20px;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
  }
`;

export const DayNumber = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const  DayDate = styled.div`
  font-size: 16px;
  opacity: 0.9;
`;

export const ActivitiesContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const ActivityCard = styled.div`
  display: flex;
  gap: 16px;
  padding: 20px;
  background: rgba(102, 126, 234, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.1);
  }

  @media (max-width: 768px) {
    padding: 0px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const ActivityImageContainer = styled.div`
  flex-shrink: 0;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

export const ActivityImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const ActivityContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const ActivityHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

export const ActivityName = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #000000ff;
  flex: 1;
`;

export const ActivityCost = styled.div`
  background: #10a969;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
`;

export const ActivityDetails = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const ActivityDescription = styled.p`
  margin: 0 0 12px 0;
  color: #4a5568;
  line-height: 1.6;
`;

export const ActivityMeta = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const MetaItem = styled.div`
  font-size: 14px;
  color: #0e5134;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  img {
    width: 1em;
    height: 1em;
    object-fit: contain;
  }
`;

export const  MetaIcon = styled.span`
  font-size: 18px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  img {
    width: 20px;
    height: 20px;
  }
`;

export const FooterSection = styled.div`
  flex: 0 0 auto; /* sticks footer at bottom */
  padding: 30px;
`;

export const FooterContent = styled.div`
  border-radius: 16px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.68);
  backdrop-filter: blur(10px);
  border-top: 2px solid rgba(102, 126, 234, 0.1);

  @media (min-width: 768px) {
    padding: 30px; /* more space on larger screens */
  }
`;

export const FooterTitle = styled.h2`
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  text-align: left;

  @media (min-width: 768px) {
    font-size: 24px; /* bigger headline on larger screens */
    margin-bottom: 20px;
  }
`;

export const EmergencyGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr; /* single column by default */
  gap: 15px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
`;

export const EmergencyCard = styled.div`
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.1);
  text-align: center;

  @media (min-width: 768px) {
    padding: 15px; /* restore padding on larger screens */
  }
`;

export const EmergencyService = styled.div`
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 4px;
  font-size: 14px;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const EmergencyNumber = styled.div`
  color: #10a969;
  font-weight: 600;
  font-size: 14px;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const ExportButton = styled.button`
  background: #0e5435;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin: 0 auto 16px auto;
  display: block;
  transition: background-color 0.2s;

  &:hover {
    background: #10a969;
  }

  @media (min-width: 768px) {
    padding: 12px 24px; /* bigger button on larger screens */
    margin-bottom: 20px;
  }

  @media print {
    display: none;
  }
`;

